import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';
import axiosInstance from '../axiosInstance';

//get all expense type
export const fetchExpenseType = createAsyncThunk(
  'camera/fetchExpenseType',
  async () => {
    try {
      const response = await axiosInstance.get('/ExpenseType');
      // console.log('response.data.getAllExpense', response.data.getAllExpense);
      return response.data.getAllExpense;
    } catch (error) {
      console.error('Error fetching expense type:', error);
      return null;
    }
  }
);

// submit expense type
export const setExpenseSubmit = createAsyncThunk(
  'expense/setExpenseSubmit',
  async (data, { getState, rejectWithValue }) => {
    try {
      const { userInfo } = getState().auth;
      const { employeeId, companyId } = userInfo;
      data['EmployeeId'] = employeeId;
      data['CompanyId'] = companyId;
      const uploadResponse = await axiosInstance.post(
        `/expenseUpload`,
        data,
        {
          headers: {
            'Content-Type': 'multipart/form-data',
          },
        }
      );
      return uploadResponse?.data?.message;
    } catch (error) {
      console.error('Error fetching expense type:', error?.response?.data);
      return rejectWithValue(error?.response?.data);
    }
  }
);


// update expense
export const expensedetailUpdate = createAsyncThunk('camera/expensedetailUpdate',
  async ({ data, unReportAttachmentIdAPI }, { rejectWithValue }) => {
    try {
      // const getUnreportedData = JSON.parse(localStorage.getItem('uploadBill')) || {};
      if (unReportAttachmentIdAPI) {
        const uploadResponse = await axiosInstance.patch(`/unreportedUpdate?unReportAttachmentId=${unReportAttachmentIdAPI}`, data,
          {
            headers: {
              'Content-Type': 'multipart/form-data',
            },
          }
        );
        return uploadResponse?.data;
      }
    } catch (error) {
      console.error('Error fetching expense type:', error.response.data);
      return rejectWithValue(error.response.data);
    }
  }
);

const initialState = {
  expenseType:[],
  captureImage: '',
  captureImageAndPdf: '',
  isLoading: false,
  apiError: null,
  errorMessage: null,
  expenseSubmitResponse:[],
}

export const cameraSlice = createSlice({
  name: 'camera',
  initialState,
  reducers: {
    setCaptureImage: (state,{payload}) => {
      state.captureImage = payload
    },
    setCaptureImageAndPdf: (state,{payload}) => {
      state.captureImageAndPdf = payload
    },
  },



  extraReducers: (builder) => {
    builder
      .addCase(fetchExpenseType.pending, (state) => {
        state.isLoading = true
      })
      .addCase(fetchExpenseType.fulfilled, (state, { payload }) => {
        state.isLoading = false
        state.expenseType = payload
        state.apiError = null
      })
      .addCase(fetchExpenseType.rejected, (state, { payload }) => {
        state.isLoading = false
        state.apiError = payload
        state.errorMessage = payload.message
      })

      // submit expense
      .addCase(setExpenseSubmit.pending, (state) => {
        state.isLoading = true
      })
      .addCase(setExpenseSubmit.fulfilled, (state, { payload }) => {
        state.isLoading = false
        state.expenseSubmitResponse = payload
        state.errorMessage = payload
        state.apiError = null
      })
      .addCase(setExpenseSubmit.rejected, (state, { payload }) => {
        state.isLoading = false
        state.apiError = true
        state.errorMessage = payload
      })

  }
})

export const {  setCaptureImage } = cameraSlice.actions
export const {  setCaptureImageAndPdf } = cameraSlice.actions


export const getAllExpenseType = (state) => state.camera.expenseType;
export const getExpenseSubmitResponse = (state) => state.camera
export const getCapturedImage = (state) => state.camera.captureImage
export const getCapturedImageAndPdf = (state) => state.camera.captureImageAndPdf
export default cameraSlice.reducer